// React imports

import { useState, useEffect, useRef } from "react";
import React from "react";

// Custom hooks
import useFetchSubtopics from "../../hooks/useFetchSubtopics";
import useFetchTopics from "../../hooks/useFetchTopics";

/* UI components */
import { BirdLoader } from "../../components/loader";

/* Styles */
import "./style.css";

/* Image assets */
import CharacterPNG from "../../assets/images/character.png";
import CharacterFlipPNG from "../../assets/images/character-flip.png";
import ClimbPNG from "../../assets/images/climb.png";
import PlayBtnPNG from "../../assets/images/play-button.png";
import GroundLeft from "../../assets/images/SubTopics/CommonLevelLeft.png";
import GroundRight from "../../assets/images/SubTopics/CommonLevelRight.png";
import TurnLadderLeft from "../../assets/images/SubTopics/Ladder/ladderclimb.png";
import TurnLadderRight from "../../assets/images/SubTopics/Ladder/ladderclimbRight.png";
import TurnGround from "../../assets/images/SubTopics/Land/levelturn.png";
import FinalGround from "../../assets/images/SubTopics/FinalGround.png";
import FirstGround from "../../assets/images/SubTopics/firstLevel.png";
import LevelBackgroundPNG from "../../assets/images/SubTopics/levelbg.png";
import successLevelBg from "../../assets/images/SubTopics/successLevelBg.png";

import BackgroundMusic from "../../assets/audios/ladder.wav";
import jumpPlayButton from "../../assets/audios/jump-play.wav";
import successSound from "../../assets/audios/congratulations.wav";
import jumpSound from "../../assets/audios/jump.wav";

import { useNavigate } from "react-router-dom";

/* Context */
import { useAuth } from "../../context/AuthContext";

// SubtopicsPage component
function SubtopicsPage({ handleClick }) {
  const [subtopics, loading] = useFetchSubtopics();
  const [isJumping, setIsJumping] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [lvlTitle, setLvlTitle] = useState("");
  const [lvlId, setLvlId] = useState(null);
  const hasSetInitialTitle = useRef(false);
  const [previousGroundId, setPreviousGroundId] = useState(null);
  const [selectedGroundId, setSelectedGroundId] = useState(null);
  const { auth, setCommonWarning, breadcrumbs, setBreadcrumbs } = useAuth();
  const [showCelebration, setShowCelebration] = useState(false);
  const [nextTopicTitle, setNextTopicTitle] = useState("");
  const [nextTopicName, setNextTopicName] = useState("");
  const [nextTopicID, setNextTopicID] = useState(null);
  const [topics] = useFetchTopics();
  const numberRefs = useRef({});
  const [positions, setPositions] = useState({});

  const audioRef = useRef(null);

  const topic =
    breadcrumbs.find((item) => item.path === "/subtopics")?.id || null;

  const currentTopicName =
    breadcrumbs.find((item) => item.path === "/subtopics")?.title || "";
  const navigate = useNavigate();
  // console.log("topics:", topics);
  // console.log("topic:", topic);
  // console.log("breadcrumbs:", breadcrumbs);

  const handleImageClick = (e, title, id) => {
    setLvlTitle(title);
    setLvlId(id);
    setSelectedGroundId(id);
  };

  useEffect(() => {
    console.log("🎯 Selected Ground ID:", selectedGroundId);
  }, [selectedGroundId]);
  useEffect(() => {
    const newPositions = {};

    Object.entries(numberRefs.current).forEach(([id, el]) => {
      if (!el) return;

      newPositions[id] = {
        left: el.offsetLeft,
        top: el.offsetTop + el.offsetHeight + 5,
      };
    });

    setPositions(newPositions);
  }, [subtopics, loading, showLoader]);
  useEffect(() => {
  if (loading || showLoader) return;
  if (!subtopics || subtopics.length === 0) return;

  const allCompleted = subtopics.every(
    (s) => s.is_completed === 1
  );

  // Reset to top when topic is fully completed
  if (allCompleted) {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
    });
    return;
  }

  // Otherwise scroll to current playable level
  const current = subtopics.find((s) => s.is_completed === 0);

  if (current) {
    const el = document.getElementById(`subtopic-${current.id}`);

    if (el) {
      requestAnimationFrame(() => {
        el.scrollIntoView({
          behavior: "auto",
          block: "end",
          inline: "nearest",
        });
      });
    }
  }
}, [loading, showLoader, subtopics]);

  useEffect(() => {
    audioRef.current = new Audio(BackgroundMusic);
    audioRef.current.loop = true;
    audioRef.current.volume = 0.3;

    audioRef.current.play().catch((err) => {
      console.error("Audio playback failed:", err);
    });

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  useEffect(() => {
    if (isJumping && !loading && !showLoader) {
      const jumpAudio = new Audio(jumpSound);
      jumpAudio.volume = 0.6;
      jumpAudio.play().catch((err) => {
        console.error("Jump sound play failed:", err);
      });
    }
  }, [isJumping, loading, showLoader]);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (topics && topics.length > 0) {
      const currentTopicIndex = topics.findIndex((t) => t.id === topic);
      // console.log("currentTopicIndex:", currentTopicIndex);
      if (currentTopicIndex !== -1 && currentTopicIndex + 1 < topics.length) {
        setNextTopicName(topics[currentTopicIndex + 1].name);
        setNextTopicID(topics[currentTopicIndex + 1].id);
      } else if (currentTopicIndex !== -1) {
        setNextTopicName(topics[currentTopicIndex].name);
        setNextTopicID(topics[currentTopicIndex].id);
      } else {
        setNextTopicName("");
        setNextTopicID(null);
      }
      // setNextTopicName(topics[0].name);
    }
  }, [topics]);

  /*
    Layout grouping logic (responsive)

    Breakpoints used:
      - width 1001..1439 => 3 cards per row
      - width 768..1000  => 2 cards per row
      - otherwise        => 4 cards per row
  */
  let splitCount;
  const width = window.innerWidth;

  if (width >= 1001 && width <= 1439) {
    // 3 cards per row
    splitCount = subtopics
      .map((_, index) => (index % 3 === 0 ? index : null))
      .filter((i) => i !== null);
  } else if (width >= 768 && width <= 1000) {
    // 2 cards per row
    splitCount = subtopics
      .map((_, index) => (index % 2 === 0 ? index : null))
      .filter((i) => i !== null);
  } else {
    // default: 4 cards per row
    splitCount = subtopics
      .map((_, index) => (index % 4 === 0 ? index : null))
      .filter((i) => i !== null);
  }

  let rows = [];

  for (let i = 0; i < splitCount.length; i++) {
    let startIdx = splitCount[i];
    let endIdx =
      splitCount[i + 1] !== undefined ? splitCount[i + 1] : subtopics.length;
    let group = subtopics.slice(startIdx, endIdx);

    if (i % 2 === 1) {
      group = [...group].reverse();
    }

    const groupWithIndex = group.map((point) => ({
      ...point,
      originalIndex: subtopics.findIndex((p) => p.id === point.id),
    }));

    rows.push(groupWithIndex);
  }

  const modifiedMapoints = rows;

  useEffect(() => {
    if (
      !hasSetInitialTitle.current &&
      modifiedMapoints?.length > 0 &&
      modifiedMapoints[0]?.length > 0
    ) {
      const firstSubtopic = modifiedMapoints[0][0];
      setLvlTitle(firstSubtopic.name);
      setLvlId(firstSubtopic.id);
      setSelectedGroundId(firstSubtopic.id);
      hasSetInitialTitle.current = true;
    }
  }, [modifiedMapoints]);

  const hasJumpedRef = useRef(false);
  useEffect(() => {
    if (!modifiedMapoints || modifiedMapoints.length === 0) return;
    if (hasJumpedRef.current) return;

    let firstIncomplete = null;
    let lastCompleted = null;

    if (Array.isArray(subtopics)) {
      // Find first incomplete
      const found = subtopics.find((sub) => sub?.is_completed !== 1);
      if (found) firstIncomplete = found;

      const completedInRow = subtopics.filter((sub) => sub?.is_completed === 1);
      if (completedInRow.length > 0) {
        lastCompleted = completedInRow[completedInRow.length - 1];
      }
    }

    // If all levels are completed, stay on the last level
    if (!firstIncomplete && lastCompleted) {
      handleImageClick(null, lastCompleted.name, lastCompleted.id);
      setSelectedGroundId(lastCompleted.id);
      setPreviousGroundId(lastCompleted.id);
      hasJumpedRef.current = true;
      return;
    }

    if (lastCompleted && firstIncomplete) {
      handleImageClick(null, firstIncomplete.name, firstIncomplete.id);
      setPreviousGroundId(lastCompleted.id);
      setSelectedGroundId(firstIncomplete.id);
      setIsJumping(true);
      hasJumpedRef.current = true;
    }
  }, [modifiedMapoints]);

  const [hasShownCelebration, setHasShownCelebration] = useState(0);

  useEffect(() => {
    // if (selectedGroundId && subtopics.length > 0) {
    //   const isLastLevel = selectedGroundId === "subtopic-0";

    //   if (isLastLevel && !isJumping) {
    //     const timer = setTimeout(() => {
    //       setShowCelebration(true);
    //       const nextTopicIndex =
    //         subtopics.findIndex((s) => s.id === selectedGroundId) + 1;
    //       if (nextTopicIndex < subtopics.length) {
    //         setNextTopicTitle(subtopics[nextTopicIndex].name);
    //       }
    //     }, 2000);

    //     return () => clearTimeout(timer);
    //   }
    // }
    // console.log("Checking for celebration modal...", hasShownCelebration);
    if (!subtopics || subtopics.length === 0) return;
    if (hasShownCelebration === 1) return;
    const currentSubtopic = subtopics.find((sub) => sub.is_completed === 0);
    const isLastLevel = currentSubtopic && currentSubtopic.id === 0;
    // console.log("currentSubtopic:", currentSubtopic);
    // console.log("isLastLevel:", isLastLevel);
    // console.log("selectedGroundId:", selectedGroundId);
    if (isLastLevel) {
      setHasShownCelebration(1);
      setTimeout(() => {
        setShowCelebration(true);
      }, 2000);
    }
  }, [selectedGroundId, isJumping, subtopics]);

  useEffect(() => {
    if (showCelebration) {
      const congratsAudio = new Audio(successSound);
      congratsAudio.volume = 0.7;
      congratsAudio.play().catch((err) => {
        console.error("Congratulations audio play failed:", err);
      });
    }
  }, [showCelebration]);

  // useEffect(() => {
  //   const flagGroundId =
  //     subtopics.length > 0 ? subtopics[subtopics.length - 1]?.id : null;

  //   const isOnFlagGround = selectedGroundId === flagGroundId;

  //   if (isOnFlagGround && !isJumping) {
  //     const timer = setTimeout(() => {
  //       setShowCelebration(true);
  //       console.log("✓ Celebration modal triggered!");
  //     }, 2000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [selectedGroundId, isJumping, subtopics]);

  const handleCelebrationAction = (action) => {
    setShowCelebration(false);

    switch (action) {
      case "next":
        const existingIndex = breadcrumbs.findIndex(
          (b) => b.path === "/subtopics",
        );

        const updated = [...breadcrumbs];
        updated[existingIndex] = {
          id: nextTopicID,
          title: nextTopicName,
          path: "/subtopics",
        };

        setBreadcrumbs(updated);
        // navigate("/subtopics");
        setTimeout(() => {
          window.location.reload();
        }, 50);
        break;
      case "explore":
        handleClick(lvlId, lvlTitle, "/topics");
        break;
      case "redo":
        handleClick(lvlId, lvlTitle, "/subtopics");
        break;
      case "reports":
        handleClick(lvlId, "Reports", "/reports");
        break;
      default:
        break;
    }
  };

  /*
    Render: The layout contains three main parts:
      1) Background SVG wrapper
      2) Loader OR the ladder/level map
      3) "Up next" footer showing selected level
  */
  return (
    <div className="climb-content-box">
      {/* Background image */}
      <div className="climb-svg-wrapper">
        <img src={ClimbPNG} alt="Game Background" />
      </div>

      {loading || showLoader ? (
        <BirdLoader />
      ) : (
        <>
          <div className="ladder-svg-wrapper">
            {modifiedMapoints && modifiedMapoints.length > 0 ? (
              modifiedMapoints.map((mapPoint, mapIndex) => {
                const rowClass = mapIndex % 2 === 0;
                const rowParity = rowClass ? "even" : "odd";
                const subTopisArr = mapPoint;

                return (
                  <React.Fragment key={mapIndex}>
                    <div className={`row row-${rowClass ? "even" : "odd"}`}>
                      {subTopisArr && subTopisArr.length > 0 ? (
                        subTopisArr.map((subtopic, index) => {
                          const originalIndex = subtopic.originalIndex;

                          const width = window.innerWidth;

                          let colsPerRow = 4;
                          if (width >= 768 && width <= 1000) {
                            colsPerRow = 2;
                          } else if (width >= 1001 && width <= 1439) {
                            colsPerRow = 3;
                          }

                          const isFirst = originalIndex === 0;
                          const isLast = originalIndex === subtopics.length - 1;
                          const isRowFirst = originalIndex % 4 === 0;
                          const isRowLast =
                            originalIndex % colsPerRow === colsPerRow - 1;

                          let imgSrc = GroundLeft;
                          let imgClass = "ground-img";
                          let charclass = "char-img";
                          let jumpClass = "jump-arc-default";
                          let PlayClass = "play-btn";

                          if (isFirst && !isLast && !isRowLast) {
                            imgSrc = FirstGround;
                            imgClass = "first-ground ground-img";
                            charclass = "char-img char-first-img";
                            jumpClass = `jump-arc-default jump-${rowParity}`;
                            PlayClass = "play-btn play-first-btn";
                          } else if (!isFirst && !isLast && isRowFirst) {
                            imgSrc = rowClass ? GroundLeft : GroundRight;
                            imgClass = "ground-img";
                            charclass = "char-img char-turnup-img";
                            jumpClass = `jump-arc-common jump-${rowParity}`;
                            PlayClass = "play-btn play-common-btn";
                          } else if (!isFirst && !isLast && isRowLast) {
                            imgSrc = TurnGround;
                            imgClass = "turn-ground ground-img";
                            charclass = "char-img char-turn-img";
                            jumpClass = `jump-arc-turn jump-${rowParity}`;
                            PlayClass = "play-btn play-turn-btn";
                          } else if (isLast) {
                            imgSrc = FinalGround;
                            imgClass = "final-ground ground-img";
                            charclass = "char-img char-final-img";
                            PlayClass = "play-btn play-final-btn";
                          } else if (!isFirst && !isLast && !isRowLast) {
                            imgSrc = rowClass ? GroundLeft : GroundRight;
                            imgClass = "ground-img";
                            charclass = "char-img char-common-img";
                            jumpClass = `jump-arc-common jump-${rowParity}`;
                            PlayClass = "play-btn play-common-btn";
                          }

                          return (
                            <React.Fragment key={index}>
                              <div
                                id={`subtopic-${subtopic.id}`}
                                className="level"
                              >
                                {(previousGroundId === subtopic.id &&
                                  isJumping) ||
                                (selectedGroundId === subtopic.id &&
                                  !isJumping) ? (
                                  <>
                                    <div className="char-wrapper">
                                      <img
                                        src={
                                          rowClass
                                            ? CharacterPNG
                                            : CharacterFlipPNG
                                        }
                                        alt="character"
                                        className={`char-img ${charclass} ${
                                          isJumping ? jumpClass : ""
                                        } ${
                                          rowClass ? "face-right" : "face-left"
                                        }`}
                                        onAnimationEnd={() => {
                                          setIsJumping(false);
                                          setPreviousGroundId(selectedGroundId);
                                        }}
                                      />
                                    </div>
                                    {originalIndex !== subtopics.length - 1 && (
                                      <div
                                        className="play-wrapper"
                                        onClick={() => {
                                          const buttonAudio = new Audio(
                                            jumpPlayButton,
                                          );
                                          buttonAudio
                                            .play()
                                            .catch((err) =>
                                              console.error(
                                                "Audio play failed:",
                                                err,
                                              ),
                                            );
                                        }}
                                      >
                                        <img
                                          onClick={() =>
                                            handleClick(
                                              lvlId,
                                              lvlTitle,
                                              `/categories`,
                                            )
                                          }
                                          src={PlayBtnPNG}
                                          alt="Play Button"
                                          style={{ cursor: "pointer" }}
                                          className={` ${PlayClass} `}
                                        />
                                      </div>
                                    )}
                                  </>
                                ) : null}

                                {originalIndex !== subtopics.length - 1 && (
                                  <>
                                    <span
                                      ref={(el) =>
                                        (numberRefs.current[subtopic.id] = el)
                                      }
                                      style={{
                                        backgroundImage: `url(${
                                          subtopic.is_completed === 1
                                            ? successLevelBg
                                            : LevelBackgroundPNG
                                        })`,
                                        color:
                                          subtopic.is_completed === 1
                                            ? "#fff"
                                            : "#3d1200",
                                      }}
                                    >
                                      {originalIndex + 1}
                                    </span>

                                    {positions[subtopic.id] && (
                                      <div
                                        className={`sublvl-badge ${
                                          subtopic.is_completed === 1
                                            ? "completed"
                                            : ""
                                        }`}
                                        style={{
                                          position: "absolute",
                                          left: positions[subtopic.id].left,
                                          top: positions[subtopic.id].top,
                                          transform: "translateX(-50%)",
                                        }}
                                      >
                                        <p className="sublvl-badge__text">
                                          {subtopic.name}
                                        </p>
                                      </div>
                                    )}
                                  </>
                                )}

                                <img
                                  src={imgSrc}
                                  alt="Ground"
                                  className={imgClass}
                                  onClick={(e) => {
                                    // Current playable level OR completed level
                                    if (
                                      subtopic.id === selectedGroundId ||
                                      subtopic.is_completed === 1
                                    ) {
                                      if (
                                        originalIndex !==
                                        subtopics.length - 1
                                      ) {
                                        handleClick(
                                          subtopic.id,
                                          subtopic.name,
                                          "/categories",
                                        );
                                      }
                                      return;
                                    }

                                    // Locked levels
                                    if (subtopic.is_completed === 0) {
                                      if (
                                        originalIndex !==
                                        subtopics.length - 1
                                      ) {
                                        setCommonWarning(
                                          "Please complete the current level to unlock this level.",
                                        );
                                      }
                                      return;
                                    }

                                    if (subtopic.id === selectedGroundId)
                                      return;

                                    handleImageClick(
                                      e,
                                      subtopic.name,
                                      subtopic.id,
                                    );
                                    setPreviousGroundId(selectedGroundId);
                                    setSelectedGroundId(subtopic.id);
                                    setIsJumping(true);
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <p>No subtopics available</p>
                      )}
                    </div>

                    {mapIndex < modifiedMapoints.length - 1 && rowClass && (
                      <div className="row row-ladder">
                        <img
                          src={TurnLadderLeft}
                          alt="Turn ladder left"
                          className="turn-ladder ladder-left ground-img"
                        />
                      </div>
                    )}
                    {mapIndex < modifiedMapoints.length - 1 && !rowClass && (
                      <div className="row row-ladder ladder-odd">
                        <img
                          src={TurnLadderRight}
                          alt="Turn ladder right"
                          className="turn-ladder ladder-right ground-img"
                        />
                      </div>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <p>No mappoints available</p>
            )}
          </div>

          {showCelebration && (
            <div className="celebration-modal-overlay">
              <div className="celebration-frame">
                <div className="triumph-banner">
                  <div className="glimmer-cluster">
                    <div className="twinkle-gem"></div>
                    <div className="twinkle-gem"></div>
                    <div className="twinkle-gem"></div>
                  </div>
                  <h1 className="cong-text">Congratulations!</h1>
                </div>

                <div className="achievement-proclamation">
                  <p>
                    You have successfully completed the topic{" "}
                    <span className="milestone-label">{currentTopicName}</span>
                  </p>
                </div>

                <div className="action-stack">
                  <button
                    className="advance-trigger topic-suc-modal"
                    onClick={() => handleCelebrationAction("next")}
                  >
                    Go to Next Topic – {nextTopicName || "Next"}
                  </button>
                  <button
                    className="discovery-pathway topic-suc-modal"
                    onClick={() => handleCelebrationAction("explore")}
                  >
                    Explore Other Topics
                  </button>
                  <button
                    className="replay-loop topic-suc-modal"
                    onClick={() => handleCelebrationAction("redo")}
                  >
                    Redo This Topic
                  </button>
                  <button
                    className="analytics-gateway topic-suc-modal"
                    onClick={() => handleCelebrationAction("reports")}
                  >
                    View Reports
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* {!isJumping && selectedGroundId !== 0 && (
            <div className="upnext-play-wrapper">
              <div className="upnext-container">
                <h4>UP NEXT : {lvlTitle}</h4>
              </div>
            </div>
          )} */}
        </>
      )}
    </div>
  );
}

export default SubtopicsPage;
